// extracted by mini-css-extract-plugin
export var leftBlob = "GradientBgInner-module--leftBlob--7b586";
export var rightBlob = "GradientBgInner-module--rightBlob--16b58";
export var root = "GradientBgInner-module--root--1fada";